import React from "react";
import { MdClose } from "react-icons/md";

import Loader from "react-loader-spinner";
import "react-phone-input-2/lib/style.css";

import { toastMessage } from "../../../utils/toast";
import * as userActions from "../../../Redux/Actions/user";
import { getLocaleValue } from "../../../utils";
import { useTranslation } from "react-i18next";

export default function RefundDisclaimerModal({
  showModal,
  loading,
  handleCancel,
  handleOk,
  history,
  footerOption1,
  footerOption2,
  type,
  t,
}) {

    
  return (
    <div>
      <div
        className="modal"
        style={{
          display: showModal ? "block" : "",
          alignItems: "center",
          top: "50%",
        }}
      >
        <div className="modal-dialog" style={{ maxWidth: "600px" }}>
          <div className="modal-content">
            <div className="modal-header">
              <h5 style={{ color: "white" }}></h5>
              <button
                type="button"
                className="close p-1 rounded"
                aria-label="Close"
                onClick={handleCancel}
                style={{ border: "none" }}
              >
                <MdClose />
              </button>
            </div>
            <div className="modal-body">
              {type === "disclaimer" ? (
                <div className="d-flex">
                  <svg
                    width="50px"
                    height="25px"
                    viewBox="0 0 24 24"
                    fill="red"
                    xmlns="http://www.w3.org/2000/svg"
                    style={{ marginRight: "10px" }}
                  >
                    <path
                      d="M12 14a1 1 0 0 1-1-1v-3a1 1 0 1 1 2 0v3a1 1 0 0 1-1 1zm-1.5 2.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0z"
                      fill="red"
                    />
                    <path
                      d="M10.23 3.216c.75-1.425 2.79-1.425 3.54 0l8.343 15.852C22.814 20.4 21.85 22 20.343 22H3.657c-1.505 0-2.47-1.6-1.77-2.931L10.23 3.216zM20.344 20L12 4.147 3.656 20h16.688z"
                      fill="red"
                    />
                  </svg>
                  <label className="font-15" style={{color: "red"}}>
                    {" "}
                    {getLocaleValue("refund_disclaimer") == "refund_disclaimer"
                      ? "Please note that refunds are subject to our refund policy. We have the right to approve or refuse the refund based on the service reason. If approved, it will be a partial refund of the service’s fees."
                      : "Please note that refunds are subject to our refund policy. We have the right to approve or refuse the refund based on the service reason. If approved, it will be a partial refund of the service’s fees."}
                  </label>
                </div>
              ) : (
                <div>
                  <div>
                    <label> Do you want to Refund this job ? </label>
                  </div>
                 
                </div>
              )}
            </div>

            <div className="modal-footer">
              <button type="button" className="btn btn-light-danger font-weight-bold" onClick={handleCancel}>{footerOption2 ? footerOption2 : 'Cancel' }</button>
                        <button type="button" className="btn btn-primary font-weight-bold d-flex align-items-center" disabled={loading} onClick={handleOk}>{footerOption1 ? footerOption1 : 'Submit'}
                            {loading && <Loader type="Oval" color="#fff" height={20} width={20} style={{marginLeft: '10px'}} />}
                        </button>
            </div>
          </div>
        </div>
      </div>
      <div className="modal-backdrop show"></div>
    </div>
  );
}
